import { IColumnsOrder, ITableColumn } from "../components/TableColumns"

export const getDefaultTableOrder = (columns: ITableColumn[]) => {
  return columns.reduce((order: IColumnsOrder, item, index) => {
    order[item.field] = index
    return order
  }, {})
}
